<template>
    <div>
        <Breadcrumbs main="Admin" submain="" title="Dashboard" />
        <!-- Container-fluid starts-->
        <div class="container-fluid"> 
            <div class="row">
                <div class="col-sm-12">
                    <px-card>
                        <div slot="with-padding">
                            <div style="width: 100%;" v-if="!loading && !error">
                                <div class="d-flex flex-column flex-md-row">
                                    <div class="col-md-4">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <router-link to="/resources/asset/list">
                                                <div class="title">Asset
                                                    <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                </div>
                                                <div class="count" v-if="asset_count.count >= 0">{{ asset_count.count }}</div>
                                            </router-link>
                                        </div>
                                    </div>
                                    <div class="col-md-4 margin-y-axis">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <router-link to="/volunteer/list">
                                                <div class="title">Volunteer
                                                    <span> <feather class="text-center" type="external-link" size="22"></feather></span>
                                                </div>
                                                <div class="count" v-if="volunteer_count.total_volunteers >= 0">{{ volunteer_count.total_volunteers }}</div>
                                            </router-link>
                                        </div>
                                    </div>
                                </div> 

                                <p class="mt-5 main-title">Asset ({{ asset_count.count }})</p>
                                <div class="d-flex flex-column flex-md-row">
                                    <div class="col-md-3">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Active</div>
                                                <div class="count" v-if="asset_count.active >= 0">{{ asset_count.active }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3 margin-y-axis">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Under Maintenance</div>
                                                <div class="count" v-if="asset_count.maintenance >= 0">{{ asset_count.maintenance }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Approval Pending</div>
                                                <div class="count" v-if="asset_count.approval >= 0">{{ asset_count.approval }}</div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-md-3">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">Inactive</div>
                                                <div class="count" v-if="asset_count.inactive >= 0">{{ asset_count.inactive }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <p class="mt-5 main-title">Volunteer ({{ volunteer_count.total_volunteers }})</p>
                                <div class="d-flex flex-column flex-md-row">
                                    <div class="col-md-3" v-for="vol_count, index in volunteer_count.data" :key="index">
                                        <div style="background-color: #fcf0e8; color: black; padding: 16px;" class="border-class">
                                            <div>
                                                <div class="title">{{ vol_count.name }}</div>
                                                <div class="count" v-if="vol_count.volunteer_count">{{ vol_count.volunteer_count }}</div>
                                            </div>
                                        </div>
                                    </div>
                                </div> 
                            </div>
                            <div v-else>
                                <loader/>
                            </div>
                        </div>
                    </px-card>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>
    
<script>
    import { mapState } from 'vuex';
    import loader from '../loader/loader.vue';

    export default {
        components: {
            loader
        },
    
        data() {
            return { }
        },
    
        computed: {
            ...mapState({
                asset_count: state => state.dashboard.asset_count,
                volunteer_count :state => state.dashboard.volunteer_count,
                loading: state => state.dashboard.dashboardCountLoading,
                error: state => state.dashboard.dashboardCountError
            })
        },
    
        mounted() {
            this.$store.dispatch("dashboard/fetchAssetCount")
            this.$store.dispatch("dashboard/fetchVolunteerCount")
        }
    };
</script>

<style scoped>
.margin-y-axis {
    margin-top: 16px;
    margin-bottom: 16px;
}

.margin-botton {
    margin-bottom: 16px;
}

.border-class {
    border-radius: 0.375rem;
}

.title {
    font-size: large; 
    font-weight: 500; 
    color: #e4701e;
}

.count {
    text-align: end; 
    font-size: xx-large; 
    font-weight: 500; 
    padding-right: 28px;
}

.main-title {
    font-size: x-large; 
    font-weight: 500;
}

@media (max-width: 1480px) {
    .main-title {
        font-size: large; 
        font-weight: 500;
    }
}

@media (max-width: 768px) {
    .count {
       padding-right: 12px;
    }
}

@media (min-width: 768px) {
    .margin-y-axis {
        margin-top: 0px;
        margin-bottom: 0px;
    }

    .margin-botton {
        margin-bottom: 0px;
    }
}
</style>
    